export const EComResult = {
  "0": "UNKNOWN",
  "1": "SUCCESS",
  "2": "FAILURE",
  "3": "EXCEPTION",
  "4": "CONNECTION",
  "5": "TIMEOUT",
  "6": "SESSION",
  "7": "AUTHORIZATION",
  "8": "PARAMETER",
  "9": "EXISTED",
  "10": "EXPIRED",
  "11": "REJECTED",
  "12": "RETRY",
  "13": "PRICE_DIFFERENCE",
  "14": "NOT_EXISTS",
  "15": "EMPTY_LIST",
  "16": "PAYMENT_POST",
  "17": "INSUFFICIENT_PAYMENT",
  "18": "INSUFFICIENT_FUNDS",
  "19": "RESERVED",
  "20": "ISSUED",
  "21": "ALREADY_IN_PROGRESS",
  "22": "ZERO_AMOUNT",
  "23": "OVERLAP_DETECTED",
  "24": "RATE_LIMIT_EXCEEDED",
  "-1": "ALL"
};

export const EExtResultCode = {
  "101": "AUTHORIZATION",
  "201": "INVALID_ADULT_COUNT",
  "202": "INVALID_CHILD_COUNT",
  "203": "INVALID_HOTEL",
  "204": "INVALID_ROOM",
  "205": "INVALID_ROOM_SELECTION",
  "300": "PRICE_DIFFERENCE",
  "301": "CANCELLATION_POLICY_DIFFERENCE",
  "302": "NOT_AVAILABLE",
  "303": "NOT_EXIST",
  "500": "INSUFFICIENT_FUNDS",
  "600": "EXCEPTION",
  "601": "CONNECTION_ERROR"
};

export const EComState = {
  "0": "UNKNOWN",
  "1": "ACTIVE",
  "2": "PASSIVE",
  "3": "DELETE",
  "4": "WILL_DELETE",
  "-1": "ALL"
};

export const EComStatus = {
  "0": "UNKNOWN",
  "1": "ACTIVE",
  "2": "PASSIVE",
  "-1": "ALL"
};

export const EComAbility = {
  "0": "UNKNOWN",
  "1": "ENABLED",
  "2": "DISABLED",
  "-1": "ALL"
};

export const EComGender = {
  "0": "UNKNOWN",
  "1": "MALE",
  "2": "FEMALE",
  "-1": "ALL"
};

export const EComLanguage = {
  "0": "UNKNOWN",
  "1": "TURKISH",
  "2": "ENGLISH",
  "3": "GERMAN",
  "4": "RUSSIAN",
  "-1": "ALL"
};

export const EComCurrency = {
  "0": "UNKNOWN",
  "1": "TRY",
  "2": "USD",
  "3": "EUR",
  "-1": "ALL"
};

export const EComCountryType = {
  "0": "UNKNOWN",
  "1": "DOMESTIC",
  "2": "INTERNATIONAL",
  "-1": "ALL"
};

export const EComApplication = {
  "0": "UNKNOWN",
  "1": "ADMIN_WEB",
  "2": "AGENT_WEB",
  "3": "AGENT_IOS",
  "4": "AGENT_ANDROID",
  "5": "ADMIN_API",
  "6": "AGENT_API",
  "7": "AGENT_MAPI",
  "8": "FLIGHT_API",
  "9": "HOTEL_API",
  "10": "CRON_API",
  "11": "PAYMENT_API",
  "12": "AGENT_SPA",
  "13": "DOCGEN_SPA",
  "14": "TRANSFER_API",
  "15": "PROVIDER_PORTAL_EXTENSION",
  "16": "RENTACAR_API",
  "17": "HOTEL_SEARCH_API",
  "18": "ADMIN_SPA",
  "19": "DATA_API",
  "20": "HOTEL_CACHE",
  "21": "BIG_JOB",
  "22": "INSURANCE_API",
  "23": "EXTRANET_API",
  "24": "EXTRANET_SPA",
  "-1": "ALL"
};

export const EComUnit = {
  "0": "UNKNOWN",
  "1": "KG",
  "2": "PC",
  "-1": "ALL"
};

export const EComLayer = {
  "0": "UNKNOWN",
  "1": "CHANNEL",
  "2": "ENGINE",
  "3": "BACKEND",
  "4": "FRONTEND",
  "-1": "ALL"
};

export const EComLogLevel = {
  "0": "UNKNOWN",
  "1": "FATAL",
  "2": "ERROR",
  "3": "WARN",
  "4": "INFO",
  "5": "DEBUG",
  "-1": "ALL"
};

export const EComObjectType = {
  "0": "UNKNOWN",
  "1": "GSA",
  "2": "AGENCY",
  "3": "PROVIDER",
  "4": "VPOS",
  "5": "BANK",
  "6": "ACCOUNT",
  "7": "USER",
  "8": "AIRPORT",
  "9": "HOTEL",
  "-1": "ALL"
};

export const EComDay = {
  "0": "UNKNOWN",
  "1": "MONDAY",
  "2": "TUESDAY",
  "3": "WEDNESDAY",
  "4": "THURSDAY",
  "5": "FRIDAY",
  "6": "SATURDAY",
  "7": "SUNDAY",
  "-1": "ALL"
};